import type { Theme } from '@mui/material';

export const styles = {
  banner: (theme: Theme) => ({
    justifyContent: 'flex-end',
    backgroundColor: theme.colors.secondary[100],
    pr: 3,
  }),

  previousVersionButton: (theme: Theme) => ({
    color: theme.colors.secondary[800],
    fontWeight: 600,
    px: [1.25],
    py: [0.75],

    '&:hover': {
      backgroundColor: 'initial',
    },
  }),
};
